/**
 * Parses a birthday date string (ISO format) into a JavaScript Date object
 * without applying timezone shifts.
 *
 * This function removes the time and timezone portion (e.g. "T00:00:00.000Z")
 * and creates the Date using year, month, and day explicitly to avoid
 * unintended timezone conversions (e.g. UTC → local time shifts).
 *
 * @function parseBirthday
 * @param {string | null | undefined} dateString - ISO date string (e.g. "1994-04-12T00:00:00.000Z")
 * @returns {Date | null} A Date object representing the exact calendar date,
 * or null if the input is falsy.
 *
 * @example
 * parseBirthday("1994-04-12T00:00:00.000Z");
 * // → Date object for 12 April 1994 (no timezone shift)
 */
export const parseBirthday = (dateString) => {
  if (!dateString) return null;

  const [year, month, day] = dateString.split("T")[0].split("-");
  return new Date(year, month - 1, day);
};
